// extracted by mini-css-extract-plugin
export default {"wrappper":"CheckoutSummary_wrappper__zcq7H","card":"CheckoutSummary_card__nU5+v","desc":"CheckoutSummary_desc__M78tt","text":"CheckoutSummary_text__1uLIv"};